// Module
var code = "<div id=\"rdc-message\"> <div class=\"panel\"> <div class=\"panel-heading\"> <h1>Remote Deposit Capture</h1> </div> <div class=\"panel-body\"> <span>{{ ::vm.message }}</span> <div class=\"margin-top-20\"> <span>Please close this window.</span> </div> </div> </div> </div> ";
// Exports
module.exports = code;